import sleep from 'sleep-promise';

import {NCBI_APIKEY} from '../../../../constants';

import {fetchGenbankSequences} from '../../../../utils/sequence-helper';

export async function getGenbankIds(medlineId) {
  if (medlineId === null) {
    return [];
  }
  const response = await fetch(
    'https://eutils.ncbi.nlm.nih.gov/entrez/eutils/elink.fcgi?dbfrom=pubmed&' +
    `db=nuccore&id=${medlineId}&retmode=json&api_key=${NCBI_APIKEY}`
  );
  const json = await response.json();
  const {linksets: [linkset]} = json;
  if (!linkset.linksetdbs) {
    return [];
  }
  const {linksetdbs: [{links}]} = linkset;
  return links;
}


const QUERYAMOUNT = 25;
const CHUNKSIZE = 8;

export async function* batchFetchGenbankSequences(
  genbankIdsWithRefs, giKey = true) {
  for (const [existingRefId, refName, gids] of genbankIdsWithRefs) {
    let chunks = [];
    let ts = (new Date()).getTime();
    for (let i = 0; i < gids.length; i += QUERYAMOUNT) {
      const partialIds = gids.slice(i, i + QUERYAMOUNT);
      const allSeqData = fetchGenbankSequences(partialIds, giKey);
      chunks.push([partialIds, allSeqData]);
      if (chunks.length === CHUNKSIZE || i + QUERYAMOUNT >= gids.length) {
        for (let [partialIds, allSeqData] of chunks) {
          allSeqData = await allSeqData;
          for (const id of partialIds) {
            const seqData = allSeqData[id];
            if (seqData) {
              seqData.existingRefId = existingRefId;
              seqData.refName = refName;
              yield seqData;
            }
          }
        }
        let tsdelta = (new Date()).getTime() - ts;
        if (tsdelta < 5000) {
          await sleep(5000 - tsdelta);
        }
        ts = (new Date()).getTime();
        chunks = [];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/genbank/genbank-utils.js